import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
// import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import Button from "react-bootstrap/Button";
import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
// import TLvsTEGraph from "../Grpahs/TLvsTEGraph";
import Slider from "react-slick";
// import AvgNoOfTotalAppliGraph from '../Grpahs/AvgNoOfTotalAppliGraph';
// import PaymentMadeByDestiGraph from "../Grpahs/PaymentMadeByDestiGraph";

// db imports
import LeadMarketing from "../database/LeadMarketing.json";
import db1 from "../database/db1.json";
import LeadsByMonth from "../database/LeadsByMonth.json";
import TotalLeadsByCountry from "../database/TotalLeadsByCountry.json";
// import PaymentMadeByDesti from '../database/PaymentMadeByDesti.json';
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import Header from "./Header";

export const LeadMarketing2 = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
  };

  return (
    <React.Fragment>
      <Header />
      <Container fluid style={{ height: "100%" }}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "50px" }}>
                    <strong>&nbsp;&nbsp;&nbsp; Lead Marketing</strong>
                  </h2>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      boxShadow: "2px 2px 8px ",
                      position: "initial",

                      height: "100px",
                      width: "210px",
                      marginTop: "3px",
                      marginLeft: "52px",
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Leads Generated
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>81.0K</h1>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop: "3px",
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Date Range
                    </Card.Header>
                    <Card.Body>
                      <DateRangeComp />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position: "initial",
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                width: "18rem",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Slider
                  {...settings}
                  className="slider"
                  style={{ margin: "1px" }}
                >
                  <div>
                    <Button variant="secondary">2017</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2019</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2020</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2021</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                </Slider>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <Card
              style={{
                marginTop: "5px",
                boxShadow: "2px 2px 8px",
                position: "initial",
                height: "100%",
              }}
            >
              <Card.Header style={{ backgroundColor: "black", color: "white" }}>
                Top 10 Campaign
              </Card.Header>
              <Card.Body className="campaign-card">
                <Scrollbars style={{ height: "100%", width: "100%" }}>
                  <div style={{ paddingRight: "15px" }}>
                    <Card className="topCampaign">
                      <Card.Body className="topCampaignBody">
                        <Card.Title>NPO - Study Abroad Canada /2021</Card.Title>
                        <Card.Subtitle>7,856</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card className="topCampaign">
                      <Card.Body className="topCampaignBody">
                        <Card.Title>NPO - Study Abroad Canada /2021</Card.Title>
                        <Card.Subtitle>7,856</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card className="topCampaign">
                      <Card.Body className="topCampaignBody">
                        <Card.Title>NPO - Study Abroad Canada /2021</Card.Title>
                        <Card.Subtitle>7,856</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card className="topCampaign">
                      <Card.Body className="topCampaignBody">
                        <Card.Title>NPO - Study Abroad Canada /2021</Card.Title>
                        <Card.Subtitle>7,856</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card className="topCampaign">
                      <Card.Body className="topCampaignBody">
                        <Card.Title>NPO - Study Abroad Canada /2021</Card.Title>
                        <Card.Subtitle>7,856</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card className="topCampaign">
                      <Card.Body className="topCampaignBody">
                        <Card.Title>NPO - Study Abroad Canada /2021</Card.Title>
                        <Card.Subtitle>7,856</Card.Subtitle>
                        <Card.Text>Lead</Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                </Scrollbars>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={8}>
            <Row>
              <Col>
                <Card
                  style={{
                    marginTop: "5px",
                    height: "220px",
                    position: "initial",
                    boxShadow: "2px 2px 8px",
                    color: "white",
                  }}
                >
                  <Card.Header style={{ backgroundColor: "black" }}>
                    Total Leads By Country
                  </Card.Header>
                  <Card.Body>
                    <div>
                      <LeadsByMonthGraph
                        title="Total Leads By Country"
                        color="#ad5238"
                        height="150"
                        db={TotalLeadsByCountry}
                        graphType="column"
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card
                  style={{
                    boxShadow: "2px 2px 8px",
                    marginTop: "5px",
                    position: "initial",
                    color: "white",
                    height: "220px",
                  }}
                >
                  <Card.Header style={{ backgroundColor: "black" }}>
                    Total Leads Vs Leads Excl DnA Deemed No and No
                  </Card.Header>
                  <Card.Body
                    style={{ paddingBottom: "7px", paddingTop: "7px" }}
                  >
                    <LeadsByMonthGraph
                      title="Total Leads Vs Leads Excl DnA Deemed No and No"
                      height="150"
                      color="#f54e55"
                      color2="#208efd "
                      db={LeadMarketing.rec2}
                      db2={LeadMarketing.rec}
                      db3={LeadsByMonth.table2}
                      graphType="area"
                      graphType2="area"
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};
